<template>
  <div>
    <b-card class="mt-2">
      <b-row>
        <div class="my-2 mx-2">
          <h3>Editar Persona</h3>
        </div>
      </b-row>
      <b-row>
        <b-col md="6">
          <label><b>Nombres: *</b></label>
          <b-form-input v-model="nombres" :class="{ 'input-error': errors.nombres }" required></b-form-input>
        </b-col>
        <b-col md="6">
          <label><b>Apellidos: *</b></label>
          <b-form-input 
            v-model="apellidos" 
            :class="{ 'input-error': errors.apellidos }"
            required
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">

        <b-col md="6">
          <label><b>Tipo de Identificación: *</b></label>
          <v-select 
            v-model="tipoIdent" 
            :options="opsTipoIdent" label="text"
            :class="{ 'input-error': errors.tipoIdent }" 
            required 
          />
        </b-col>

        <b-col md="6">
          <label><b>Identificación: *</b></label>
          <b-form-input 
            v-model="identificacion" 
            :class="{ 'input-error': errors.identificacion }"
            :maxlength="tipoIdent.value === '1' ? 10 : null" 
            @input="validarIdentificacion"
            required
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col md="4">
          <label><b>Teléfono: *</b></label>
          <b-form-tags 
            v-model="celular" 
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            :tag-validator="tagValidator" 
            separator=" " 
            input-type="number" 
            placeholder="099999999"
            :class="{ 'input-error': errors.celular }" 
            required 
          />
        </b-col>
        <b-col md="4">
          <label><b>Correo: *</b></label>
          <b-form-input 
            v-model="email" 
            :class="{ 'input-error': errors.email }" 
            required
          />
        </b-col>
        <b-col md="4">
          <label><b>Fecha Nacimiento:</b></label>
          <b-form-datepicker v-model="fechaNacimiento" dropright></b-form-datepicker>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <div style="width: 90%;" class="text-right">
          <b-button variant="success" @click="editarPersona">
            Editar persona
          </b-button>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>

import { BootstrapVue } from 'bootstrap-vue';
import vSelect from 'vue-select'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';



export default {
  name: "EditarPersona",


  components: {
    ...BootstrapVue.components,
    vSelect,
    axios,
    rutas,

  },
  props: {
    idPersona: {
      type: String,
      default: null,
    },
  },




  data() {

    return {
      opsTipoIdent: [
        { value: '0', text: 'RUC' },
        { value: '1', text: 'Cedula' },
        { value: '2', text: 'Passporte' }
      ],

      identificaciones: null,
      nombres: null,
      apellidos: null,
      tipoIdent: { value: '1', text: 'Cedula' },
      identificacion: null,
      celular: [],
      email: null,
      fechaNacimiento: null,

      errors: {
        nombres: false,
        apellidos: false,
        tipoIdent: false,
        identificacion: false,
        celular: false,
        email: false,
      }
    }
  },

  created() {
    this.fetchPersonaById()
    this.fetchPersonas()
  },

  methods: {
    async fetchPersonaById() {
      const query = `
        query MyQuery($idPersona: ID) {
          getPersonaById(idPersona: $idPersona) {
            correo
            telefono
            identificacion
            primerApellido
            primerNombre
            primerApellido
            fechaNacimiento
            id 
          }
        }
      `;

      const variables = {
        idPersona: this.idPersona
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
                
        const persona        = response.data.data.getPersonaById;
        this.nombres         = persona.primerNombre || ""
        this.apellidos       = persona.primerApellido || ""
        this.identificacion  = persona.identificacion || ""
        this.celular         = persona.telefono || ""
        this.email           = persona.correo || ""
        this.fechaNacimiento = persona.fechaNacimiento || ""

      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },


    async fetchPersonas(search = '') {
      const query = `
        query MyQuery($search: String) {
          allPersona(search: $search) {
            correo
            telefono
            identificacion
            primerApellido
            primerNombre
            primerApellido
            id 
          }
        }
      `;

      const variables = {
        search,
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });

        const personas = response.data.data.allPersona;
        const identificaciones = [];
        personas.forEach(persona => {
          identificaciones.push(persona.identificacion);
        });

        this.identificaciones = identificaciones
      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },

    async validarIdentificacion() {
      await this.esIdentificacionRepetida()

      if (this.tipoIdent === '1' && this.identificacion.length > 10) {
        this.identificacion = this.identificacion.slice(0, 10);
      }
    },

    validarCampos() {
      let isValid = true;

      // Resetear errores
      this.errors = {
        nombres       : false,
        apellidos     : false,
        tipoIdent     : false,
        identificacion: false,
        celular       : false,
        email         : false,
      };

      // Validar cada campo
      if (!this.nombres) {
        this.errors.nombres = true;
        isValid = false;
      }

      if (!this.apellidos) {
        this.errors.apellidos = true;
        isValid = false;
      }

      if (!this.tipoIdent) {
        this.errors.tipoIdent = true;
        isValid = false;
      }
      if (!this.identificacion || this.identificacion.length < 10 || this.identificacionrepetida) {
        this.errors.identificacion = true;
        isValid = false;
      }
      if (!this.celular.length) {
        this.errors.celular = true;
        isValid = false;
      }
      if (!this.email) {
        this.errors.email = true;
        isValid = false;
      }

      if (!isValid) {
        const identRepetida = `Ingrese una identificacion que no exista`
        const mensaje       = 'Por favor, complete todos los campos obligatorios.'
        
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: this.identificacionrepetida ? identRepetida : mensaje,
        });
      }

      return isValid;

    },


    tagValidator(tag) {
      const isValid = /^\d+$/.test(tag) && tag.length < 11
      this.tagError = isValid ? '' : 'Solo se permiten valores numéricos hasta de 10 caracteres'
      return isValid
    },

    async editarPersona() {

      if (!this.validarCampos()) return;

      const query = `
        mutation actualizarPersona (
          $nombres           : String,
          $sexo              : String,
          $apellidos         : String,
          $estadoCivil       : String,
          $tipoIdent         : String,
          $identificacion    : String,
          $telefono          : String,
          $fechaNacimiento   : String
          $email             : String,
          $nacionalidad      : String,
          $nivelEducacion    : String,
          $profesion         : String,
          $pueKichwa         : String,
          $tipoBono          : String,
          $nacioEtni         : String,
          $callePrincipal    : String,
          $calleSecundaria   : String,
          $referencia        : String,
          $barrio            : String,
          $urlIdentificacion : String,
          $urlCarnet         : String,
          $esDiscapacitado   : Int
          $idPersona         : String!
        ){

          actualizarPersona(
            nombres           : $nombres
            apellidos         : $apellidos
            sexo              : $sexo
            tipoIdent         : $tipoIdent
            estadoCivil       : $estadoCivil
            identificacion    : $identificacion
            telefono          : $telefono
            fechaNacimiento   : $fechaNacimiento
            email             : $email
            nacionalidad      : $nacionalidad
            nivelEducacion    : $nivelEducacion
            profesion         : $profesion
            pueKichwa         : $pueKichwa
            tipoBono          : $tipoBono
            nacioEtni         : $nacioEtni
            callePrincipal    : $callePrincipal
            calleSecundaria   : $calleSecundaria
            referencia        : $referencia
            barrio            : $barrio
            urlIdentificacion : $urlIdentificacion
            esDiscapacitado   : $esDiscapacitado
            urlCarnet         : $urlCarnet
            idPersona         : $idPersona
          ){
            persona {
              token,id
            }
            status,
            message
          }
        } 
      `;
      
      const variables = {
        idPersona       : this.idPersona,
        nombres         : this.nombres,
        apellidos       : this.apellidos,
        nacioEtni       : '',
        tipoIdent       : this.tipoIdent ? this.tipoIdent.value : '1',
        identificacion  : this.identificacion,
        telefono        : this.celular.join(','),
        email           : this.email,
        fechaNacimiento : this.fechaNacimiento ? this.fechaNacimiento : '31-12-2000',
        estadoCivil     : '',
        nacionalidad    : '',
        nivelEducacion  : '',
        profesion       : '',
        pueKichwa       : '',
        tipoBono        : '',
        barrio          : '',
        callePrincipal  : '',
        sexo            :'0',
        calleSecundaria : '',
        referencia      : '',
        urlIdentificacion: '',
        urlCarnet       : '',
        esDiscapacitado : 0,
        identificacionrepetida: false,
      };


      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });

        if (response.status === 200) {
          if (response.data.data.actualizarPersona.status === 'success') {
            const { token, id } = response.data.data.actualizarPersona.persona;
            if (id > 0) {
              await this.$swal.fire({
                icon: 'success',
                title: 'Exito',
                text: `Persona editada correctamente .`,
              });
                
              this.$router.go(0)
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Error al editar la persona ${response.data.data.actualizarPersona.message} .`,
              });
            }
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: `Presenta el siguiente error ${response.data.data.actualizarPersona.message} .`,
          });
        }

      } catch (err) {
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: `Presenta el siguiente error ${err} .`,
        });
      }
      console.log(err);
      return 0;
    },
    async esIdentificacionRepetida(){
      if(this.identificacion && this.identificacion.length > 9) {
        if (this.identificaciones.includes(this.identificacion)) {
          this.$toast.error("La identificacion ya fue ingresada anteriormente!");
          this.identificacionrepetida = true
        } else {
          this.$toast.success("Identificacion correcta");
          this.identificacionrepetida = false
        }
      }
    }
  },

}


</script>

<style>
.input-error {
    border-color: red !important;
}
</style>